module.exports = __webpack_public_path__ + "static/img/nofind.17b3f29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/nofind.png
// module id = PTW+
// module chunks = 1